import React from 'react'
import { Redirect } from 'react-router-dom'
import { SEO } from '../../../components/Seo/seo'
import { useIntl } from 'react-intl'
import Layout from '../../../components/Dashboard/Layout/Layout'
import { NamedRoutes } from '../../../routes'
import { paymentRequests } from '../../../utils/pages-meta.json'
import { AuthenticatedUserConsumer } from '../../../AuthenticatedUserContext'
import { FormLoader } from '../../../components/Loader/FormLoader'
import PaymentRequestsContent from '../../../components/Dashboard/Subscription/PaymentRequestsContent'
import { LanguageConsumer } from '../../../LanguageContext'


const SubscriptionPaymentRequests = () => {
  const intl = useIntl()
  return (
    <>
      <SEO title={intl.formatMessage({ id: 'PaymentsContent.ActionLinks.PaymentRequests' })}
           pathname={window.location.origin}
           titleTemplate={intl.formatMessage({ id: 'E-Tax' })}
           image={paymentRequests.image}
           description={intl.formatMessage({ id: 'PaymentsContent.ActionLinks.PaymentRequests' })}
      />
      <AuthenticatedUserConsumer>
        {({ userDataLoading, userData, handleNotificationCall }) => (
          <>
            {!!userDataLoading && <FormLoader loading={true}/>}
            {!!Object.keys(userData).length &&
            <>
              {!!userData.is_admin ?
                <Layout content={<LanguageConsumer>
                  {({ locale }) => (
                    <PaymentRequestsContent handleNotificationCall={handleNotificationCall} locale={locale}/>
                  )}
                </LanguageConsumer>}/> :
                (!userDataLoading && <Redirect to={NamedRoutes.home}/>)
              }
            </>
            }
          </>
        )}
      </AuthenticatedUserConsumer>
    </>
  )
}

export default SubscriptionPaymentRequests

